var map = {
	"./1.jpg": 6759,
	"./10.jpg": 4807,
	"./11.jpg": 2618,
	"./12.jpg": 8869,
	"./13.jpg": 1000,
	"./2.jpg": 4184,
	"./3.jpg": 5093,
	"./33.jpg": 1070,
	"./34.jpg": 1957,
	"./4.jpg": 558,
	"./5.jpg": 7019,
	"./6.jpg": 9324,
	"./7.jpg": 6697,
	"./8.jpg": 7074,
	"./9.jpg": 7071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1758;